import { render, staticRenderFns } from "./RadioYesNo.vue?vue&type=template&id=8f0c971a"
import script from "./RadioYesNo.vue?vue&type=script&lang=js"
export * from "./RadioYesNo.vue?vue&type=script&lang=js"
import style0 from "./RadioYesNo.vue?vue&type=style&index=0&id=8f0c971a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports